import React from 'react'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import AddTeacherForm from './components/AddTeacherForm'
import CustomDivider from '../../shared/utils/CustomDivider'
import AssignCourseToTeacher from './components/AssignCourseToTeacher'

const SchoolAddTeachers = () => {
    return (
        <>
           
                <AddTeacherForm />
  
            <CustomDivider />
            <NormalContainerWithHeader headerText={"Add Course to teachers"}>
                <AssignCourseToTeacher />
            </NormalContainerWithHeader>

        </>
    )
}

export default SchoolAddTeachers
